import { render, staticRenderFns } from "./CollectDid.vue?vue&type=template&id=da45560c&scoped=true&"
import script from "./CollectDid.vue?vue&type=script&lang=js&"
export * from "./CollectDid.vue?vue&type=script&lang=js&"
import style0 from "./CollectDid.vue?vue&type=style&index=0&id=da45560c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45560c",
  null
  
)

export default component.exports